import { Button, ButtonProps, useTheme } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type FastActionButtonProps = ButtonProps & {
  label: string;
  redirectUrl: string;
};

const FastActionButton: FC<FastActionButtonProps> = ({ label, redirectUrl, ...props }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      size="large"
      sx={{
        width: "100%",
        fontSize: "1.15rem",
        height: "56px",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[2],
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          boxShadow: theme.shadows[4],
        },
      }}
      onClick={() => navigate(redirectUrl)}
      {...props}
    >
      {label}
    </Button>
  );
};

export default FastActionButton;
